// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ServiceWorker from "../serviceWorker/ServiceWorker.bs.jsx";
import * as FirebaseConfig from "./firebaseConfig";
import * as Messaging from "firebase/messaging";

let FirebaseOptions = {};

let FirebaseApp = {};

let Analytics = {};

let Transaction = {};

let WriteBatch = {};

let User = {};

let EmailAuthProvider = {
  providerID: "password"
};

let GithubAuthProvider = {
  providerID: "github.com"
};

let GoogleAuthProvider = {
  providerID: "google.com"
};

let FederatedAuthProvider = {};

let Auth = {
  EmailAuthProvider: EmailAuthProvider,
  GithubAuthProvider: GithubAuthProvider,
  GoogleAuthProvider: GoogleAuthProvider,
  FederatedAuthProvider: FederatedAuthProvider
};

let appCheckToken = FirebaseConfig.APP_CHECK_TOKEN;

let PersistentTabManager = {};

let FirestoreLocalCache = {
  PersistentTabManager: PersistentTabManager
};

let AppCheckProvider = {};

async function getToken(messaging) {
  let serviceWorkerRegistration = await ServiceWorker.serviceWorkerRegistration;
  return await Messaging.getToken(messaging, {
    serviceWorkerRegistration: serviceWorkerRegistration,
    vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY
  });
}

let Messaging$1 = {
  getToken: getToken
};

let Timestamp = {};

let StyledFirebaseAuth = {};

let Functions = {};

export {
  FirebaseOptions,
  FirebaseApp,
  Analytics,
  Transaction,
  WriteBatch,
  User,
  Auth,
  appCheckToken,
  FirestoreLocalCache,
  AppCheckProvider,
  Messaging$1 as Messaging,
  Timestamp,
  StyledFirebaseAuth,
  Functions,
}
/* appCheckToken Not a pure module */
